export default "__VITE_ASSET__8dGeeA_4__"